import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'zah-header',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent {

  @Input()
  menuEnabled: boolean;
  @Output()
  menuClick: EventEmitter<void> = new EventEmitter<void>();

  onMenuClick(): void {
    this.menuClick.emit();
  }
}
